








































































































































import Vue from 'vue';
/* globals process */
import { requiredIf } from 'vuelidate/lib/validators';
import { FormValidation } from '@/mixins';
import { EventBus } from '@/event-bus';
import { api, ADDRESS_VALIDATION_API_SUB_URLS } from '@/api';
import { ExtendMixins } from '@/services';

interface Data {
  addressModel: any;
  isLoading: boolean;
  showValidateAddressErrorMessage: boolean;
  validateAddressErrorHeaderTitle: string[];
  validateAddressErrorHeaderText: string[];
  responseData: any;
  houseNumber: string;
}

export default ExtendMixins(
  FormValidation,
).extend({
  name: 'ValidateAddress',
  props: {
    address: {
      type: Object as () => any,
      required: true,
    },
    validateAddressIsLoading: {
      type: Boolean,
      default: false,
    },
    jwt: {
      type: String,
      default: '',
    },
  },
  data(): Data {
    return {
      addressModel: '',
      isLoading: false,
      showValidateAddressErrorMessage: false,
      validateAddressErrorHeaderTitle: this.$options.filters.t(
        'validate-address_error_default_header-title',
      ),
      validateAddressErrorHeaderText: this.$options.filters.t(
        'validate-address_error_default_header-text',
      ),
      responseData: {},
      houseNumber: '',
    };
  },
  watch: {
    validateAddressIsLoading(val) {
      if (val) {
        this.addressModel = this.stringifyAddress(this.address);
        this.validateAddress(this.addressModel);
      }
    },
  },
  beforeMount() {
    this.showErrorModel.houseNumber = false;
  },
  validations: {
    houseNumber: {
      required: requiredIf(function(this: any): boolean {
        return this.responseData.verifyLevel === 'StreetPartial';
      }),
    },
  },
  computed: {
    // VALIDATIONS
    houseNumberErrors(): string[] {
      const formField = 'houseNumber';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'validate-address_form-error_house-number_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
  },
  methods: {
    stringifyAddress(address): string {
      let addressString = `${address.addressLine1}`;
      if (this.address.addressLine2) {
        addressString += ` ${address.addressLine2}`;
      }
      addressString += ` ${address.city}, ${address.state} ${address.zipCode}`;
      return addressString;
    },
    chooseAddress(address): void {
      this.isLoading = true;
      this.requestAddress(address.id)
        .then((data) => {
          this.isLoading = false;
          this.showValidateAddressErrorMessage = false;
          this.$emit('addressValidationSuccess', data.data);
        })
        .catch(() => {
          this.isLoading = false;
          EventBus.$emit('openModal', 'Error', {
            message: 'global_connection-error',
            action: {
              label: 'global_dismiss',
              performAction: () => {
                this.cancelAddressValidation();
              },
            },
            hideCancel: true,
          });
        });
    },
    requestAddress(id): Promise<any> {
      const headers: {
        'x-api-key': string;
        Authorization?: string;
      } = {
        'x-api-key': process.env.VUE_APP_TOKEN_API_KEY,
      };
      if (this.jwt) {
        headers.Authorization = this.jwt;
      }
      return api.get(`${ADDRESS_VALIDATION_API_SUB_URLS.addresses}/${id}`, {
        headers,
      });
    },
    validateHouseNumber(): void {
      const newAddressLine1 = this.address.addressLine1.substr(
          this.address.addressLine1.indexOf(' ') + 1,
        ),
        newAddress = Object.assign({}, this.address, {
          addressLine1: `${this.houseNumber} ${newAddressLine1}`,
        }),
        newAddressString = this.stringifyAddress(newAddress);
      this.validateAddress(newAddressString);
    },
    cancelAddressValidation(): void {
      this.showValidateAddressErrorMessage = false;
      this.$emit('addressValidationCancel');
    },
    validateAddress(address): void {
      this.isLoading = true;

      const headers: {
        'x-api-key': string;
        Authorization?: string;
      } = {
        'x-api-key': process.env.VUE_APP_TOKEN_API_KEY,
      };
      if (this.jwt) {
        headers.Authorization = this.jwt;
      }

      api
        .get(`${ADDRESS_VALIDATION_API_SUB_URLS.addresses}`, {
          headers,
          params: {
            search: address,
          },
        })
        .then((data) => {
          const response = data.data,
            verifyLevel = response.verifyLevel;

          this.responseData = response;

          if (verifyLevel === 'Verified') {
            // VERIFIED
            this.showValidateAddressErrorMessage = false;
            this.$emit('addressValidationSuccess', response.address);
          } else if (typeof verifyLevel !== 'undefined') {
            // EVERYTHING ELSE
            this.validateAddressErrorHeaderTitle = [
              `validate-address_error_${verifyLevel.toLowerCase()}_header-title`,
            ];
            this.validateAddressErrorHeaderText = [
              `validate-address_error_${verifyLevel.toLowerCase()}_header-text`,
            ];
            this.showValidateAddressErrorMessage = true;
            this.isLoading = false;
          } else {
            // NO MATCHES
            this.showValidateAddressErrorMessage = false;
            this.$emit('addressValidationNoMatches');
          }
        })
        .catch((error) => {
          if (error.status === 404) {
            this.validateAddressErrorHeaderTitle = [
              `validate-address_error_interactionrequired_header-title`,
            ];
            this.validateAddressErrorHeaderText = [
              `validate-address_error_interactionrequired_header-text`,
            ];
            this.showValidateAddressErrorMessage = true;
            this.isLoading = false;
          } else {
            this.isLoading = false;
            EventBus.$emit('openModal', 'Error', {
              message: 'global_connection-error',
              action: {
                label: 'global_dismiss',
                performAction: () => {
                  this.cancelAddressValidation();
                },
              },
              hideCancel: true,
            });
          }
        });
    },
    useAsEntered(): void {
      this.showValidateAddressErrorMessage = false;
      this.$emit('addressValidationSuccess', this.address);
    },
    useSuggested(): void {
      this.showValidateAddressErrorMessage = false;
      this.$emit('addressValidationSuccess', this.responseData.address);
    },
  },
});
